import { http, HttpResponse } from 'msw';

import {
  HorseChangeColorRequest,
  HorseChangeColorResponse,
  HorseChangeNameRequest,
  HorseChangeNameResponse,
} from '~/server/src/dtos';
import { extractParams } from '~/utils';

import { horses } from './apiMockData';

const horsesHandlers = [
  http.get('*/horses/:id', ({ request }) => {
    const { id } = extractParams<{ id: string }>(request.url, '/horses/:id');
    const horse = horses.find((h) => h.horseId === id);
    if (horse) return HttpResponse.json(horse);
    return HttpResponse.json({ message: `horse ${id} not found` }, { status: 404 });
  }),

  http.put('*/horses/:horseId/name', async ({ params, request }) => {
    const horseId = params.horseId as string | undefined;
    const { name } = (await request.json()) as HorseChangeNameRequest;
    const horse = horses.find((h) => h.horseId === horseId);
    if (horse) horse.name = name;

    const response: HorseChangeNameResponse = { name };
    return HttpResponse.json(response);
  }),

  http.put('*/horses/:horseId/color', async ({ params, request }) => {
    const horseId = params.horseId as string | undefined;
    const { color } = (await request.json()) as HorseChangeColorRequest;
    const horse = horses.find((h) => h.horseId === horseId);
    if (horse) horse.color = color;

    const response: HorseChangeColorResponse = { color };
    return HttpResponse.json(response);
  }),
];

export default horsesHandlers;
